import React from "react";
import classnames from "classnames";
import connect from "Shared/connect";
import * as searchHistory from "../../../../../Search/search-history";
import { loadQuickSearch, hideQuickSearch, showQuickSearch, closeQuickSearch, updateSelectedCompletion, clearQuickSearchCart, setQuickSearchText, } from "../../../../../Search/action-creators";
import Autocompletions from "./Autocompletions";
import { DOWN, UP, ESC, TAB, ENTER, PLUS, MINUS, PLUS_DESKTOP, MINUS_DESKTOP, } from "Shared/keyboard";
import { searchPageUrl } from "Shared/known-urls";
import Icon from "Shared/Icon";
import SearchButton from "./Button";
import currentPageIsSearch from "../../../../../Search/Pages/Search/current-page-is-search";
import { currentUrl, areEqual, urlToString } from "Shared/url";
import { loadPage } from "SiteLayout/CurrentPage/action-creators";
import * as Root from "SiteLayout/Root";
import * as styles from "./base.scss";
import { setMainMenu } from "SiteLayout/MainMenu/action-creators";
import { epiPropertyValue } from "@avensia/nitro5-scope-episerver";
import Spinner from "Shared/Spinner";
import { translate } from "Shared/translate";
import { pushState } from "Shared/history";
class QuickSearch extends React.PureComponent {
    constructor(props) {
        super(props);
        this.previousSearchWasPreview = false;
        this.onKeyDown = (event) => {
            switch (event.keyCode) {
                case ENTER:
                    event.preventDefault();
                    if (this.searchInputHasFocus) {
                        this.loadResults();
                        this.props.hideQuickSearch();
                        this.searchInput.blur();
                    }
                    break;
                case PLUS_DESKTOP:
                case TAB:
                case DOWN:
                case PLUS:
                    event.preventDefault();
                    this.moveSelection("next");
                    break;
                case UP:
                case MINUS:
                case MINUS_DESKTOP:
                    event.preventDefault();
                    this.moveSelection("prev");
                    break;
                case ESC:
                    // Prevent default because Chrome clears the value of a input[type="search"]
                    // on escape
                    event.preventDefault();
                    this.searchInput.blur();
                    this.props.hideQuickSearch();
                    break;
                default:
                    break;
            }
        };
        this.onAutocompleClick = (text) => {
            searchHistory.add(text);
        };
        this.state = {
            loadingQuickSearch: false,
            ABTrackingIsSent: false,
        };
    }
    getAllContent() {
        return this.props.quickSearch.completionsLists.reduce((a, b) => a.concat(!!b.content ? b.content : []), []);
    }
    getAllCompletions() {
        return this.props.quickSearch.completionsLists.reduce((a, b) => a.concat(!!b.items ? b.items : []), []);
    }
    getAllProducts() {
        return this.props.quickSearch.completionsLists.reduce((a, b) => a.concat(!!b.products ? b.products : []), []);
    }
    componentDidMount() {
        this.setQuerySuggestionVisibility();
        this.unbindRootClick = Root.on("click", () => {
            if (this.props.quickSearch.isOpen) {
                this.props.hideQuickSearch();
            }
            this.searchInputHasFocus = false;
        });
    }
    componentDidUpdate() {
        this.setQuerySuggestionVisibility();
    }
    componentWillUnmount() {
        this.unbindRootClick && this.unbindRootClick();
        this.clearSearchTimeouts();
        if (this.searchInput) {
            this.searchInput.removeEventListener("input", this.searchOnInput);
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.searchInput && !this.searchInputHasFocus) {
            this.searchInput.value = nextProps.quickSearch.searchText;
        }
    }
    clearSearchTimeouts() {
        clearTimeout(this.currentSearchTimeout);
    }
    setQuerySuggestionVisibility() {
        const sw = this.querySuggestionElement.scrollWidth;
        const cw = this.querySuggestionElement.clientWidth;
        const visible = sw <= cw;
        this.querySuggestionElement.style.visibility = visible ? "" : "hidden";
    }
    moveSelection(direction) {
        let selectedCompletionType = this.props.quickSearch.selectedCompletionType;
        if (selectedCompletionType === "product" && !this.props.isLoggedIn) {
            selectedCompletionType = "content";
        }
        let newSelectedIndex = -1;
        let collection = selectedCompletionType === "product"
            ? this.getAllProducts()
            : selectedCompletionType === "content"
                ? this.getAllContent()
                : this.getAllCompletions();
        newSelectedIndex = this.getNewSelection(direction, collection, this.props.quickSearch.selectedCompletionIndex);
        if (newSelectedIndex < 0) {
            if (direction === "prev") {
                selectedCompletionType =
                    selectedCompletionType === "product"
                        ? "item"
                        : selectedCompletionType === "item"
                            ? "content"
                            : !this.props.isLoggedIn
                                ? "item"
                                : "product";
            }
            else {
                selectedCompletionType =
                    selectedCompletionType === "product"
                        ? "content"
                        : selectedCompletionType === "content"
                            ? "item"
                            : !this.props.isLoggedIn
                                ? "content"
                                : "product";
            }
            collection =
                selectedCompletionType === "product"
                    ? this.getAllProducts()
                    : selectedCompletionType === "item"
                        ? this.getAllCompletions()
                        : this.getAllContent();
            newSelectedIndex = this.getNewSelection(direction, collection, newSelectedIndex);
        }
        if (selectedCompletionType !== "product" && !this.searchInputHasFocus) {
            this.searchInput.focus();
        }
        this.props.updateSelectedCompletion(newSelectedIndex, selectedCompletionType);
        if (newSelectedIndex >= 0) {
            this.setPreviousSearch();
        }
    }
    getNewSelection(direction, list, selectedIndex) {
        if (direction === "next") {
            return selectedIndex + 1 > list.length - 1 ? -1 : selectedIndex + 1;
        }
        else {
            return selectedIndex >= 0
                ? selectedIndex - 1
                : list.length > 0
                    ? list.length - 1
                    : -1;
        }
    }
    searchUrl(searchText, preview) {
        return {
            path: searchPageUrl().url,
            query: { q: searchText },
            hiddenQuery: preview ? { preview } : null,
        };
    }
    loadResults() {
        this.displayQuickSearch = false;
        const query = this.props.quickSearch.searchText;
        searchHistory.add(query);
        const newUrl = this.searchUrl(query, true);
        this.previousSearch = query;
        // Note that we perform the page load regardless of whether the same result is already loaded.
        // This is because we want to load it without the preview parameter to notify eSales of the actual search.
        if (areEqual(currentUrl(), newUrl)) {
            this.props.loadPage(urlToString(newUrl), false);
        }
        else {
            this.go(query);
        }
    }
    setPreviousSearch() {
        const query = (this.props.quickSearch.suggestion || this.props.quickSearch.searchText).trim();
        if (this.previousSearch !== query) {
            this.previousSearch = query;
            this.previousSearchWasPreview = true;
        }
    }
    go(searchText) {
        if (searchText.length) {
            this.previousSearch = searchText;
            this.previousSearchWasPreview = false;
            let newUrl = this.searchUrl(searchText, false);
            const products = this.getAllProducts();
            if (products.length == 1) {
                var item = products[0];
                const itemCode = epiPropertyValue(item.content.code);
                newUrl = this.searchUrl(itemCode, false);
            }
            if (!areEqual(currentUrl(), newUrl)) {
                pushState(urlToString(newUrl));
            }
        }
    }
    onChange(event) {
        const searchText = event.target.value;
        if (searchText === this.props.quickSearch.searchText) {
            return;
        }
        if (searchText.length !== 0) {
            this.clearSearchTimeouts();
            this.displayQuickSearch = true;
            this.props.setQuickSearchText(searchText);
            this.setState({ loadingQuickSearch: true });
            if (searchText.length > 1) {
                this.currentSearchTimeout = setTimeout(() => {
                    const query = (this.props.quickSearch.suggestion ||
                        this.props.quickSearch.searchText).trim();
                    this.props.loadQuickSearch(searchText).then(() => {
                        this.setState({
                            loadingQuickSearch: false,
                            ABTrackingIsSent: true,
                        });
                    });
                    if (this.displayQuickSearch) {
                        this.props.showQuickSearch();
                    }
                    if (this.previousSearch !== query) {
                        this.previousSearch = query;
                        this.previousSearchWasPreview = true;
                    }
                }, this.props.debounceTimeForSearch);
            }
        }
        else {
            this.props.closeQuickSearch();
            this.onClear();
            this.props.showQuickSearch();
            this.searchInputHasFocus = true;
        }
    }
    onSearchClick(e) {
        e.preventDefault();
        this.props.hideQuickSearch(false);
        this.loadResults();
        this.searchInput.blur();
    }
    onClear() {
        this.searchInput.focus();
        this.props.loadQuickSearch("");
        const quick = document.getElementById("quicksearch");
        quick.value = "";
        this.searchInputHasFocus = false;
        this.props.hideQuickSearch();
    }
    onInputFocus() {
        this.previousSearch = this.props.quickSearch.searchText;
        this.searchInputHasFocus = true;
        this.props.showQuickSearch();
    }
    onInputBlur() {
        this.searchInputHasFocus = false;
    }
    onInputClick() {
        this.props.loadQuickSearch(this.props.quickSearch.searchText);
        this.props.updateSelectedCompletion(-1, "product");
        this.searchInputHasFocus = true;
    }
    onAutocompleProductClick() {
        this.props.hideQuickSearch();
    }
    render() {
        const { searchText, completionsLists } = this.props.quickSearch;
        const suggestion = this.props.quickSearch.suggestion || "";
        const hasProducts = completionsLists.reduce((i, l) => i + (l.products && l.products.length ? l.products.length : 0), 0) > 0;
        const showResult = this.displayQuickSearch || this.searchInputHasFocus;
        return (React.createElement("form", { className: classnames(styles.quickSearch, this.props.className), onClick: (e) => {
                e.stopPropagation();
            } },
            React.createElement("div", { className: classnames(styles.inputContainer, this.searchInputHasFocus && styles.focused) },
                React.createElement("div", { className: styles.querySuggestion, ref: (el) => (this.querySuggestionElement = el) },
                    React.createElement("span", { className: styles.querySuggestionPrefix }, suggestion.length > 1 && suggestion.substr(0, searchText.length)),
                    React.createElement("span", null, suggestion.length > 1 && suggestion.substr(searchText.length))),
                React.createElement("div", { className: styles.absoluteWrapper },
                    React.createElement("input", { type: "search", name: "q", id: "quicksearch", autoComplete: "off", defaultValue: searchText, ref: (el) => (this.searchInput = el), placeholder: translate("/QuickSearch/NewPlaceholder"), onChange: (e) => this.onChange(e), onKeyDown: (event) => this.onKeyDown(event), onFocus: () => this.onInputFocus(), onBlur: () => this.onInputBlur(), onClick: () => this.onInputClick() })),
                this.props.quickSearch.searchText.length > 1 && (React.createElement("button", { type: "button", className: styles.clear, onClick: (e) => this.onClear() }, this.state.loadingQuickSearch ? (React.createElement(Spinner, { className: styles.smallspinner })) : (React.createElement(Icon, { name: "close" })))),
                React.createElement(SearchButton, { className: classnames(styles.button, "ui-test-search-button"), element: (el) => (this.searchButtonElement = el), onClick: (e) => this.onSearchClick(e) })),
            React.createElement(Autocompletions, { onItemClick: this.onAutocompleClick, lists: completionsLists, selectedIndex: this.props.quickSearch.selectedCompletionIndex, selectedCompletionType: this.props.quickSearch.selectedCompletionType, searchText: searchText, thinSelection: !hasProducts, onKeyDown: this.onKeyDown, visible: showResult })));
    }
}
export default connect((state) => ({
    isLoggedIn: !!state.currentUser && state.currentUser.isLoggedIn,
    currentUser: state.currentUser,
    currentPageIsSearch: currentPageIsSearch(state),
    quickSearch: state.quickSearch,
    debounceTimeForSearch: state.appShellData.siteSettings.searchDebounce
}), (dispatch) => ({
    loadPage(url, showSpinner, shouldUseResult) {
        dispatch(loadPage(url, { hideSpinner: !showSpinner }, null, shouldUseResult));
    },
    loadQuickSearch: (searchText) => dispatch(loadQuickSearch(searchText)),
    setQuickSearchText: (searchText) => dispatch(setQuickSearchText(searchText)),
    updateSelectedCompletion(index, type) {
        dispatch(updateSelectedCompletion(index, type));
    },
    hideQuickSearch(setFirstSuggestionAsSearchText = true) {
        dispatch(hideQuickSearch(setFirstSuggestionAsSearchText));
    },
    showQuickSearch() {
        dispatch(setMainMenu(false));
        dispatch(showQuickSearch());
    },
    closeQuickSearch() {
        dispatch(closeQuickSearch());
    },
    clearQuickSearchCart: () => dispatch(clearQuickSearchCart()),
}))(QuickSearch);
